import { Controller } from "stimulus";
import "selectize";

export default class extends Controller {
  static targets = ["select"];
  static values = {
    maxItems: { type: String, default: "1" },
    placeholder: { type: String, default: "Type to search..." },
  };

  connect() {
    if (!this.hasSelectTarget) {
      return;
    }

    const $select = $(this.selectTarget);
    $select.selectize({
      create: false,
      maxItems: this.selectizeMaxItems(),
      selectOnTab: true,
      placeholder: this.placeholderValue,
      onChange: () => {
        // Ensure listeners bound to native change events still run.
        this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    this.selectize = $select[0].selectize;
  }

  disconnect() {
    if (this.selectize) {
      this.selectize.destroy();
      this.selectize = null;
    }
  }

  selectizeMaxItems() {
    const raw = this.maxItemsValue;
    if (raw === "multi" || raw === "null") {
      return null;
    }
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? 1 : parsed;
  }
}
